// @ts-nocheck
/**
 * ツインキーシステム - 属性別汎用スキル
 *
 * 42種のスキル（7属性 × 2コスト帯 × 3スキル）
 * 仕様書: twin_key_generic_skills_passives_v1.md
 */

import { COST_BANDS } from '../categoryMapping';

// ========================================
// スキル効果タイプ定義
// ========================================

export const SKILL_EFFECT_TYPES = {
  // ダメージ系
  DAMAGE_SINGLE: 'damage_single',       // 単体ダメージ
  DAMAGE_ALL: 'damage_all',             // 全体ダメージ
  DAMAGE_RANDOM: 'damage_random',       // ランダム対象ダメージ
  DAMAGE_MULTI_HIT: 'damage_multi_hit', // 複数回攻撃

  // 回復系
  HEAL_SINGLE: 'heal_single',           // 単体回復
  HEAL_ALL: 'heal_all',                 // 全体回復
  HEAL_SELF: 'heal_self',               // 自己回復
  REVIVE: 'revive',                     // 蘇生

  // バフ系
  BUFF_SINGLE: 'buff_single',           // 単体バフ
  BUFF_ALL: 'buff_all',                 // 全体バフ
  BUFF_SELF: 'buff_self',               // 自己バフ

  // デバフ系
  DEBUFF_SINGLE: 'debuff_single',       // 単体デバフ
  DEBUFF_ALL: 'debuff_all',             // 全体デバフ

  // 状態異常系
  STATUS_INFLICT: 'status_inflict',     // 状態異常付与
  STATUS_CURE: 'status_cure',           // 状態異常解除

  // 複合系
  DAMAGE_AND_STATUS: 'damage_and_status',
  HEAL_AND_BUFF: 'heal_and_buff',
  DAMAGE_AND_DEBUFF: 'damage_and_debuff',
};

// ========================================
// 状態異常タイプ
// ========================================

export const STATUS_TYPES = {
  BURN: 'burn',           // 火傷
  FREEZE: 'freeze',       // 凍結
  PARALYSIS: 'paralysis', // 麻痺
  CURSE: 'curse',         // 呪い
  SILENCE: 'silence',     // 沈黙
  TIME_STOP: 'time_stop', // 時止
  POISON: 'poison',       // 毒
  EXHAUST: 'exhaust',     // 虚脱
};

// ========================================
// バフ/デバフタイプ
// ========================================

export const BUFF_TYPES = {
  ATK_UP: 'atk_up',
  ATK_DOWN: 'atk_down',
  DEF_UP: 'def_up',
  DEF_DOWN: 'def_down',
  SPD_UP: 'spd_up',
  SPD_DOWN: 'spd_down',
  CRIT_UP: 'crit_up',
  EVASION_UP: 'evasion_up',
  REGEN: 'regen',         // 再生
  DAMAGE_REDUCE: 'damage_reduce', // 被ダメ軽減
  COUNTER: 'counter',     // 反撃
  INVINCIBLE: 'invincible', // 無敵
  TAUNT: 'taunt',         // 挑発
};

// ========================================
// 炎属性スキル（6種）
// ========================================

export const FIRE_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'fire_low_1',
      name: 'ファイアボール',
      description: '敵単体に攻撃×1.2ダメージ',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2 },
      ],
    },
    {
      id: 'fire_low_2',
      name: 'フレイムバースト',
      description: '敵単体に攻撃×1.5ダメージ、20%で火傷',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.5, status: STATUS_TYPES.BURN, chance: 0.2 },
      ],
    },
    {
      id: 'fire_low_3',
      name: '業火の渦',
      description: '敵全体に攻撃×0.9ダメージ、30%で火傷',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.9 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.BURN, chance: 0.3, target: 'all_enemies' },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'fire_mid_1',
      name: '炎槍',
      description: '敵単体に攻撃×1.3ダメージ、15%で火傷',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.3, status: STATUS_TYPES.BURN, chance: 0.15 },
      ],
    },
    {
      id: 'fire_mid_2',
      name: '紅蓮の息吹',
      description: '敵全体に攻撃×0.8ダメージ、火傷×1付与',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.8 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.BURN, stacks: 1, chance: 1.0, target: 'all_enemies' },
      ],
    },
    {
      id: 'fire_mid_3',
      name: 'インフェルノ',
      description: '敵全体に攻撃×1.1ダメージ、火傷×2付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.1 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.BURN, stacks: 2, chance: 1.0, target: 'all_enemies' },
      ],
    },
  ],
};

// ========================================
// 水属性スキル（6種）
// ========================================

export const WATER_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'water_low_1',
      name: 'アクアショット',
      description: '敵単体に攻撃×1.2ダメージ',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2 },
      ],
    },
    {
      id: 'water_low_2',
      name: '癒しの水',
      description: '味方単体HP40%回復',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SINGLE, healPercent: 0.4 },
      ],
    },
    {
      id: 'water_low_3',
      name: 'フロストウェーブ',
      description: '敵全体に攻撃×0.8ダメージ、20%で凍結',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.8 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.FREEZE, chance: 0.2, target: 'all_enemies' },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'water_mid_1',
      name: '氷槍',
      description: '敵単体に攻撃×1.3ダメージ、10%で凍結',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.3, status: STATUS_TYPES.FREEZE, chance: 0.1 },
      ],
    },
    {
      id: 'water_mid_2',
      name: '水鏡の守り',
      description: '味方全体に防御↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.DEF_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'water_mid_3',
      name: 'タイダルウェーブ',
      description: '敵全体に攻撃×1.0ダメージ、速度↓×1付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.0 },
        { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.SPD_DOWN, stacks: 1 },
      ],
    },
  ],
};

// ========================================
// 光属性スキル（6種）
// ========================================

export const LIGHT_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'light_low_1',
      name: 'ライトアロー',
      description: '敵単体に攻撃×1.2ダメージ（闇に×1.3）',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2, attributeBonus: { '闇': 1.3 } },
      ],
    },
    {
      id: 'light_low_2',
      name: '光の癒し',
      description: '味方単体HP35%回復、状態異常1つ解除',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SINGLE, healPercent: 0.35 },
        { type: SKILL_EFFECT_TYPES.STATUS_CURE, count: 1 },
      ],
    },
    {
      id: 'light_low_3',
      name: 'シャインブラスト',
      description: '敵全体に攻撃×0.9ダメージ、15%で麻痺',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.9 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.PARALYSIS, chance: 0.15, target: 'all_enemies' },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'light_mid_1',
      name: '聖光撃',
      description: '敵単体に攻撃×1.3ダメージ（闇に×1.4）、10%で麻痺',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.3, attributeBonus: { '闇': 1.4 }, status: STATUS_TYPES.PARALYSIS, chance: 0.1 },
      ],
    },
    {
      id: 'light_mid_2',
      name: '祝福の光',
      description: '味方全体HP25%回復',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_ALL, healPercent: 0.25 },
      ],
    },
    {
      id: 'light_mid_3',
      name: 'ホーリージャッジメント',
      description: '敵全体に攻撃×1.0ダメージ、麻痺×1付与（25%）',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.0 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.PARALYSIS, stacks: 1, chance: 0.25, target: 'all_enemies' },
      ],
    },
  ],
};

// ========================================
// 闇属性スキル（6種）
// ========================================

export const DARK_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'dark_low_1',
      name: 'ダークショット',
      description: '敵単体に攻撃×1.2ダメージ',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2 },
      ],
    },
    {
      id: 'dark_low_2',
      name: '呪詛の霧',
      description: '敵単体に攻撃×1.0ダメージ、呪い付与',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.0, status: STATUS_TYPES.CURSE, chance: 1.0 },
      ],
    },
    {
      id: 'dark_low_3',
      name: 'シャドウバインド',
      description: '敵単体に攻撃×1.8ダメージ、攻撃↓×1付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_DEBUFF, multiplier: 1.8, debuff: BUFF_TYPES.ATK_DOWN, stacks: 1 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'dark_mid_1',
      name: '闇の牙',
      description: '敵単体に攻撃×1.3ダメージ、与ダメの15%吸収',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.3, lifesteal: 0.15 },
      ],
    },
    {
      id: 'dark_mid_2',
      name: 'カースフィールド',
      description: '敵全体に呪い付与、攻撃↓×1付与',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.CURSE, chance: 1.0, target: 'all_enemies' },
        { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.ATK_DOWN, stacks: 1 },
      ],
    },
    {
      id: 'dark_mid_3',
      name: 'ダークネスヴォイド',
      description: '敵全体に攻撃×1.0ダメージ、呪い付与、30%で沈黙',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.0 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.CURSE, chance: 1.0, target: 'all_enemies' },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.SILENCE, chance: 0.3, target: 'all_enemies' },
      ],
    },
  ],
};

// ========================================
// 未来属性スキル（6種）
// ========================================

export const FUTURE_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'future_low_1',
      name: 'クロノショット',
      description: '敵単体に攻撃×1.2ダメージ',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2 },
      ],
    },
    {
      id: 'future_low_2',
      name: '加速術式',
      description: '味方単体に速度↑×2付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SINGLE, buff: BUFF_TYPES.SPD_UP, stacks: 2, duration: 3 },
      ],
    },
    {
      id: 'future_low_3',
      name: 'タイムストライク',
      description: '敵単体に攻撃×1.8ダメージ、時止付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.8, status: STATUS_TYPES.TIME_STOP, chance: 1.0 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'future_mid_1',
      name: '時空裂断',
      description: '敵単体に攻撃×1.3ダメージ、15%で時止',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.3, status: STATUS_TYPES.TIME_STOP, chance: 0.15 },
      ],
    },
    {
      id: 'future_mid_2',
      name: '未来視',
      description: '味方全体にクリティカル↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_ALL, buff: BUFF_TYPES.CRIT_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'future_mid_3',
      name: 'クロノブレイク',
      description: '敵全体に攻撃×0.9ダメージ、時止×1付与、速度↓×1付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.9 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.TIME_STOP, stacks: 1, chance: 1.0, target: 'all_enemies' },
        { type: SKILL_EFFECT_TYPES.DEBUFF_ALL, debuff: BUFF_TYPES.SPD_DOWN, stacks: 1 },
      ],
    },
  ],
};

// ========================================
// 原始属性スキル（6種）
// ========================================

export const PRIMITIVE_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'primitive_low_1',
      name: 'ポイズンバイト',
      description: '敵単体に攻撃×1.1ダメージ、毒×1付与',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.1, status: STATUS_TYPES.POISON, stacks: 1, chance: 1.0 },
      ],
    },
    {
      id: 'primitive_low_2',
      name: '野生の再生',
      description: '自身にHP15%回復、再生×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SELF, healPercent: 0.15 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.REGEN, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'primitive_low_3',
      name: '猛毒の牙',
      description: '敵単体に攻撃×1.5ダメージ、毒×2付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.5, status: STATUS_TYPES.POISON, stacks: 2, chance: 1.0 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'primitive_mid_1',
      name: '原始の咆哮',
      description: '敵単体に攻撃×1.3ダメージ、防御↓×1付与',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_DEBUFF, multiplier: 1.3, debuff: BUFF_TYPES.DEF_DOWN, stacks: 1 },
      ],
    },
    {
      id: 'primitive_mid_2',
      name: '大地の息吹',
      description: '自身にHP25%回復、再生×2付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.HEAL_SELF, healPercent: 0.25 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.REGEN, stacks: 2, duration: 3 },
      ],
    },
    {
      id: 'primitive_mid_3',
      name: 'パンデミック',
      description: '敵全体に攻撃×0.8ダメージ、毒×2付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 0.8 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.POISON, stacks: 2, chance: 1.0, target: 'all_enemies' },
      ],
    },
  ],
};

// ========================================
// 無属性スキル（6種）
// ========================================

export const NEUTRAL_SKILLS = {
  [COST_BANDS.LOW]: [
    {
      id: 'neutral_low_1',
      name: 'エナジーショット',
      description: '敵単体に攻撃×1.2ダメージ',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 1.2 },
      ],
    },
    {
      id: 'neutral_low_2',
      name: '集中',
      description: '自身に攻撃↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.ATK_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'neutral_low_3',
      name: 'フォースインパクト',
      description: '敵単体に攻撃×2.0ダメージ',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_SINGLE, multiplier: 2.0 },
      ],
    },
  ],
  [COST_BANDS.MID]: [
    {
      id: 'neutral_mid_1',
      name: 'マジックブレイク',
      description: '敵単体に攻撃×1.3ダメージ、15%で虚脱',
      skillSlot: 1,
      unlockLevel: 20,
      cooldown: 2,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_AND_STATUS, multiplier: 1.3, status: STATUS_TYPES.EXHAUST, chance: 0.15 },
      ],
    },
    {
      id: 'neutral_mid_2',
      name: 'オーラチャージ',
      description: '自身に攻撃↑×2、クリティカル↑×1付与（3T）',
      skillSlot: 2,
      unlockLevel: 40,
      cooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.ATK_UP, stacks: 2, duration: 3 },
        { type: SKILL_EFFECT_TYPES.BUFF_SELF, buff: BUFF_TYPES.CRIT_UP, stacks: 1, duration: 3 },
      ],
    },
    {
      id: 'neutral_mid_3',
      name: 'ヴォイドブラスト',
      description: '敵全体に攻撃×1.0ダメージ、虚脱×1付与',
      skillSlot: 3,
      unlockLevel: 60,
      cooldown: 5,
      initialCooldown: 3,
      effects: [
        { type: SKILL_EFFECT_TYPES.DAMAGE_ALL, multiplier: 1.0 },
        { type: SKILL_EFFECT_TYPES.STATUS_INFLICT, status: STATUS_TYPES.EXHAUST, stacks: 1, chance: 1.0, target: 'all_enemies' },
      ],
    },
  ],
};

// ========================================
// 属性スキルマップ
// ========================================

export const ATTRIBUTE_SKILLS = {
  '炎': FIRE_SKILLS,
  '水': WATER_SKILLS,
  '光': LIGHT_SKILLS,
  '闇': DARK_SKILLS,
  '未来': FUTURE_SKILLS,
  '原始': PRIMITIVE_SKILLS,
  'なし': NEUTRAL_SKILLS,
};

/**
 * 属性とコスト帯からスキルセットを取得
 * @param {string} attribute - 属性
 * @param {string} costBand - コスト帯
 * @returns {Object[]} スキル配列（3つ）
 */
export const getAttributeSkills = (attribute, costBand) => {
  const attrSkills = ATTRIBUTE_SKILLS[attribute];
  if (!attrSkills) {
    // 未知の属性は無属性として扱う
    return NEUTRAL_SKILLS[costBand] || NEUTRAL_SKILLS[COST_BANDS.LOW];
  }

  return attrSkills[costBand] || attrSkills[COST_BANDS.LOW];
};

export default {
  SKILL_EFFECT_TYPES,
  STATUS_TYPES,
  BUFF_TYPES,
  ATTRIBUTE_SKILLS,
  getAttributeSkills,
};
